import { AnalyticsPayload } from '../AnalyticsEvent';

const withLocation = <T extends AnalyticsPayload>(payload: T): T & { location: string } => ({
  ...payload,
  location: window.location.href
});

export default withLocation;
